import React from "react";
import { Typography, Box, Button } from "@mui/material";
import WorkflowDiagram from "../tutorial/WorkflowDiagram";
import { FONT_SIZES } from "../../constants/fontSizes";

import { colors } from "../../constants/colors";

const ShortIntro = ({ title, customStyles }) => {
  const styles = { ...localStyles, ...customStyles };

  return (
    <>
      <Typography sx={{ ...styles.paragraph }}>
        <strong>{title}</strong> is a name generator, trademark analysis, and
        domain research tool for founders, creatives, and IP attorneys. {title}{" "}
        helps you find powerful brand names fast, matches your brand names with
        available domains so you can reach your market, and informs you of legal
        risk with trademark name conflict analysis.
      </Typography>
      <Box sx={styles.workflowDiagramParent}>
        <WorkflowDiagram customStyles={styles.workflowDiagram} />
      </Box>
    </>
  );
};

export default ShortIntro;

const localStyles = {
  paragraph: {
    fontSize: FONT_SIZES.PARAGRAPH,
    color: "black",
  },
  workflowDiagramParent: {
    mt: 4,
    mb: 4,
    display: "flex",
    justifyContent: "center",
  },
};
